import {callAjaxGet, objectToFormData} from "../../utils";
import $ from "jquery";
import {getExternByFamily, postExtern} from "../usuario/usuario";

export const getCargosFundeo = async (errorHandling) => {
    const cargos = await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/fundeo/cargos`, errorHandling);
    return cargos.map(c => {
        return {
            ...c, front: diccionarioCargos[diccionarioCargos.findIndex(a => a.api_name === c.cargo)].front
        }
    })
}

export const getCargoFundeoById = async (chargeId, errorHandling) => {
    const cargo = await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/fundeo/cargos/${chargeId}`, errorHandling);
    return {
        ...cargo,
        front: diccionarioCargos[diccionarioCargos.findIndex(a => a.api_name === cargo.cargo)].front
    }
}

export const getPeopleByCargoFundeo = async (charge, errorHandling) => {
    return await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/fundeo/cargos?cargo=${charge}`, errorHandling);
}

export const getCargosExtHerFundeo = async (errorHandling) => {
    const cargos = (await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/familia/disponibles`, errorHandling)).fundeo;
    cargos.cargosHer = cargos.cargosHer.map(c => diccionarioCargos.find(d => d.api_name === c).front);
    cargos.cargosExt = cargos.cargosExt.map(c => diccionarioCargos.find(d => d.api_name === c).front);
    return cargos;
};

const diccionarioCargos = [
    {
        front: {name: "Patronato", charge: "Presidenta"},
        api_name: "Presidenta del patronato"
    },
    {
        front: {name: "Patronato", charge: "Vicepresidenta"},
        api_name: "Vicepresidenta del patronato"
    },
    {
        front: {name: "Patronato", charge: "Secretaria"},
        api_name: "Secretaria del patronato"
    },
    {
        front: {name: "Patronato", charge: "Vocales"},
        api_name: "Vocal del patronato"
    },
    {
        front: {name: "Sede central", charge: "Dirección general"},
        api_name: "Director/a general"
    },
    {
        front: {name: "Sede central", charge: "Área técnica"},
        api_name: "Director/a de área"
    },
    {
        front: {name: "Delegaciones", charge: "Andalucía"},
        api_name: "Delegado/a Andalucia"
    },
    {
        front: {name: "Delegaciones", charge: "Aragón"},
        api_name: "Delegado/a Aragon"
    },
    {
        front: {name: "Delegaciones", charge: "Canarias"},
        api_name: "Delegado/a Canarias"
    },
    {
        front: {name: "Delegaciones", charge: "Castilla León"},
        api_name: "Delegado/a Castilla Leon"
    },
    {
        front: {name: "Delegaciones", charge: "Cataluña"},
        api_name: "Delegado/a Cataluna"
    },
    {
        front: {name: "Delegaciones", charge: "La Rioja"},
        api_name: "Delegado/a La Rioja"
    },
    {
        front: {name: "Delegaciones", charge: "Navarra"},
        api_name: "Delegado/a Navarra"
    },
    {
        front: {name: "Delegaciones", charge: "Valencia"},
        api_name: "Delegado/a Valencia"
    },
    {
        front: {name: "Comisión de proyectos", charge: "Comisionados"},
        api_name: "Comision de proyectos"
    },
    {
        front: {name: "Comisión de voluntarios", charge: "Comisionados"},
        api_name: "Comision de voluntarios"
    },
    {
        front: {name: "Comisión de gestión", charge: "Comisionados"},
        api_name: "Comision de gestion"
    }
]

export const formPostFundeo = async (nuevos, aBorrar) => {
    const promises = [];
    nuevos.forEach(nuevo => {
        const form = objectToFormData({
            startDate: nuevo.startDate,
            endDate: nuevo.endDate,
            cargo: diccionarioCargos.find(c => c.front.name === nuevo.front.name && c.front.charge === nuevo.front.charge).api_name,
            externoId: nuevo.externoId,
            sisterId: nuevo.sisterId,

        }, true);
        if (nuevo.id) {
            promises.push(putCargoFundeo(form, nuevo.id))
        } else {
            promises.push(postCargoFundeo(form))
        }
    })

    aBorrar.forEach(borrar => {
        promises.push(deleteCargoFundeo(borrar.id))
    })

    for (let promise in promises) {
        try {
            await promise;
        } catch (e) {
            alert(e)
        }
    }
}

export const postCargoFundeo = async (cargo) => {
    let settings = {
        url: process.env.REACT_APP_API_URL + `/fundeo/cargos`,
        method: "POST",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
        data: cargo,
    };
    return $.ajax(settings);
};

export const putCargoFundeo = async (cargo, id) => {
    let settings = {
        url: process.env.REACT_APP_API_URL + `/fundeo/cargos/${id}`,
        method: "PUT",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
        data: cargo,
    };
    return $.ajax(settings);
};

export const deleteCargoFundeo = async (id) => {
    let settings = {
        url: process.env.REACT_APP_API_URL + `/fundeo/cargos/${id}`,
        method: "DELETE",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
    };
    return $.ajax(settings);
};

export const getExternFundeo = async (errorHandling, name = null) => {
    return await getExternByFamily("FUNDEO", errorHandling, name);
}

export const postExternFundeo = async (data) => {
    await postExtern({...data, familia: "FUNDEO"});
};

export const putExternFundeo = async (data) => {
    await postExtern({...data, familia: "FUNDEO"});
};